import { useEffect, useState } from "react";
import { baseUrl } from "./constants";

const useGetInfluencerById = (id) => {
  const [influencer, setInfluencer] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");

  const getData = async () => {
    try {
      const response = await fetch(`${baseUrl}/register-creators/${id}`, {
        headers: {
          "auth-token": token,
        },
      });
      const data = await response.json();
      setInfluencer(data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setInfluencer([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  return [influencer, isLoading];
};

export default useGetInfluencerById;
